var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"2"}},[_c('path',{class:_vm.variant,attrs:{"d":"M0 0h26v2H0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }